import {useEffect} from 'react';

// This hook is deprecated, use useMountEffect instead
function useOnce(once) {
    return useEffect(once, [once]);
}

export default useOnce;
